import { Toast } from 'primereact/toast';
import { useDispatch, useSelector } from 'react-redux';
import React, { useRef, useEffect } from 'react';
import { ClearToast } from '../redux/actions/ToasterAction';

const ProToaster = () => {
    const toaster = useSelector(state => state.toaster);
    const dispatch = useDispatch()
    const toast = useRef(null)
    useEffect(() => {
        if(toaster.toaster.summary){
            if(toaster.toaster.summary === 'Error') {
                toaster.toaster.severity = 'error';
                toaster.toaster.life = 10000;
            }
            showToaster(toaster.toaster);
            dispatch(ClearToast())
        }
    },[toaster, dispatch])
    
    const showToaster = (toaster) => {
        toast.current.show(toaster);
    }

    return(
        <Toast ref={toast} />
    )
}

export default ProToaster;